"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageLogTotalsStruct = exports.WebPushMessagePayloadStruct = exports.WhatsAppMessagePayloadStruct = exports.SMSMessagePayloadStruct = exports.MailMessagePayloadStruct = exports.UIMessagePayloadStruct = exports.SendResultStruct = exports.MessageRecordStruct = exports.MessageStatusEnums = exports.MessageProviderEnums = exports.BillableMessageTypeEnums = exports.MessageTypeEnums = exports.MessageRecipientStruct = exports.MessageStruct = exports.FREE_WHATSAPP_AMOUNT = exports.FREE_SMS_AMOUNT = void 0;
/* Messaging system */
const superstruct_1 = require("superstruct");
const utils_1 = require("../utils");
const locale_1 = require("./locale");
const price_1 = require("./price");
exports.FREE_SMS_AMOUNT = 100;
exports.FREE_WHATSAPP_AMOUNT = 100;
exports.MessageStruct = (0, superstruct_1.type)({
    templateName: (0, superstruct_1.string)(),
    data: (0, superstruct_1.any)(),
    subject: (0, superstruct_1.string)(),
    body: (0, superstruct_1.string)(),
});
exports.MessageRecipientStruct = (0, superstruct_1.object)({
    placeId: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    appointmentId: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    email: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    webPushToken: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    phoneNumber: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    whatsappConsent: (0, superstruct_1.optional)((0, superstruct_1.any)()),
});
exports.MessageTypeEnums = (0, superstruct_1.enums)(['ui', 'sms', 'web-push', 'mail', 'whatsapp']);
exports.BillableMessageTypeEnums = (0, superstruct_1.enums)(['sms', 'whatsapp']);
exports.MessageProviderEnums = (0, superstruct_1.enums)(['ui', 'sms', 'web-push', 'mail', 'whatsapp', 'bulkgate']);
exports.MessageStatusEnums = (0, superstruct_1.enums)([
    'NEW',
    'DISPATCH_PENDING',
    'DISPATCH_SUCCESS',
    'DISPATCH_FAILURE',
    'DELIVERY_SUCCESS',
    'DELIVERY_FAILURE',
]);
exports.MessageRecordStruct = (0, superstruct_1.object)({
    id: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    userId: (0, superstruct_1.string)(),
    placeId: (0, superstruct_1.string)(),
    organisationId: (0, superstruct_1.string)(),
    placeName: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    createdAt: utils_1.TimestampStruct,
    type: exports.MessageTypeEnums,
    foreignId: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    message: exports.MessageStruct,
    recipient: exports.MessageRecipientStruct,
    price: (0, superstruct_1.optional)(price_1.PriceStruct),
    countryCode: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    status: exports.MessageStatusEnums,
    delivery: (0, superstruct_1.optional)((0, superstruct_1.any)()),
});
exports.SendResultStruct = (0, superstruct_1.object)({
    status: exports.MessageStatusEnums,
    foreignId: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    price: (0, superstruct_1.optional)((0, superstruct_1.object)({
        amount: (0, superstruct_1.number)(),
        currency: (0, superstruct_1.string)(),
    })),
    country: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    delivery: (0, superstruct_1.optional)((0, superstruct_1.any)()),
});
exports.UIMessagePayloadStruct = (0, superstruct_1.object)({
    id: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    userId: (0, superstruct_1.string)(),
    appData: (0, superstruct_1.optional)((0, superstruct_1.object)({
        tag: (0, superstruct_1.string)(),
        timestamp: (0, superstruct_1.any)(),
        timezone: (0, superstruct_1.string)(),
        locale: locale_1.LocaleLongStruct,
    })),
    message: exports.MessageStruct,
    status: (0, superstruct_1.enums)(['new', 'received']),
    createdAt: (0, superstruct_1.any)(),
});
exports.MailMessagePayloadStruct = (0, superstruct_1.object)({
    to: (0, superstruct_1.string)(),
    message: (0, superstruct_1.object)({
        subject: (0, superstruct_1.string)(),
        html: (0, superstruct_1.string)(),
        text: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    }),
});
exports.SMSMessagePayloadStruct = (0, superstruct_1.object)({
    originator: (0, superstruct_1.string)(),
    body: (0, superstruct_1.string)(),
    type: (0, superstruct_1.string)(),
    recipients: (0, superstruct_1.array)((0, superstruct_1.string)()),
});
exports.WhatsAppMessagePayloadStruct = (0, superstruct_1.object)({
    to: (0, superstruct_1.string)(),
    type: (0, superstruct_1.string)(),
    channelId: (0, superstruct_1.string)(),
    content: (0, superstruct_1.object)({
        hsm: (0, superstruct_1.object)({
            namespace: (0, superstruct_1.string)(),
            templateName: (0, superstruct_1.string)(),
            language: (0, superstruct_1.object)({
                policy: (0, superstruct_1.string)(),
                code: (0, superstruct_1.string)(),
            }),
            components: (0, superstruct_1.array)((0, superstruct_1.object)({
                type: (0, superstruct_1.string)(),
                parameters: (0, superstruct_1.any)(),
            })),
        }),
    }),
});
exports.WebPushMessagePayloadStruct = (0, superstruct_1.object)({
    data: (0, superstruct_1.object)({
        id: (0, superstruct_1.string)(),
        title: (0, superstruct_1.string)(),
        body: (0, superstruct_1.string)(),
        badge: (0, superstruct_1.string)(),
        icon: (0, superstruct_1.string)(),
    }),
});
exports.MessageLogTotalsStruct = (0, superstruct_1.object)({
    count: (0, superstruct_1.number)(),
    priceTotals: (0, superstruct_1.any)(),
});
//# sourceMappingURL=messaging.js.map